<template>
  <section class="users section">
    <div class="container">
      <h1 class="title">Notifications Settings</h1>
      <loading v-if="loading" class="white-bg shadow-card" />
      <error-alert v-if="error.active" />
      <div v-if="notifications.data.length > 0 && !loading">
        <div class="table-responsive rounded desktop-shadow-card">
          <table class="table table-striped mb-0 rounded">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Title</th>
                <th>Description</th>
                <th class="text-center">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="notification in notifications.data"
                class="mobile-tablet-shadow-card rounded"
                :key="notification.id"
              >
                <td>
                  <b class="mobile-tablet-only mr-2">ID:</b
                  >{{ notification.id }}
                </td>
                <td>
                  <b class="mobile-tablet-only mr-2">Name:</b>
                  {{ notification.setting_name }}
                </td>
                <td>
                  <b class="mobile-tablet-only mr-2">Title:</b
                  >{{ notification.title }}
                </td>
                <td
                  v-html="
                    `<b class='mobile-tablet-only mr-2'>Description:</b>` +
                    $options.filters.nl2br(notification.details)
                  "
                ></td>

                <!-- <td class="text-center"><i class="fas fa-fw" :class="notification.active ? `fa-check text-success` : `fa-times text-secondary`"></i></td> -->
                <td class="text-center status-select">
                  <b class="mobile-tablet-only mr-2 mt-2">Status:</b>
                  <alert
                    v-if="saving[notification.id]"
                    :emptySlot="true"
                    type="loader"
                    class="text-center mb-0 mt-2 loader"
                    color="secondary"
                  />
                  <div class="form-group mb-0 mt-2">
                    <select
                      :id="notification.id"
                      v-if="!saving[notification.id]"
                      :class="`form-control ${
                        notification.active ? 'btn-success' : 'btn-danger'
                      } `"
                      v-model="notification.active"
                      @input="updateNotification(notification)"
                    >
                      <option
                        v-for="status in statuses"
                        :key="status.value"
                        :value="status.value"
                      >
                        {{ status.label }}
                      </option>
                    </select>
                  </div>
                </td>
                <td class="text-right buttons-td">
                  <router-link
                    :to="`/admin/notifications-settings/${notification.id}/edit`"
                    class="btn btn-secondary btn-sm mr-1"
                    ><i class="fas fa-edit" title="edit"></i
                    ><span class="mobile-tablet-only pl-2"
                      >Edit</span
                    ></router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "notificationsSettings",
  data() {
    return {
      saving: {},
      statuses: [
        { value: 1, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    };
  },
  computed: {
    ...mapState(["notifications", "error"]),
    loading: function () {
      return this.$store.state.loading;
    },
  },
  mounted() {
    this.$store.dispatch("notifications/all");
  },
  methods: {
    updateNotification: function (notification) {
      this.saving = {
        ...this.saving,
        [notification.id]: true,
      };
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store
        .dispatch("notifications/update", notification)
        .then((result) => {
          this.saving = {
            ...this.saving,
            [notification.id]: false,
          };
          if (!result) {
            notification.active = notification.active ? 0 : 1;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1024px) {
  .status-select {
    display: flex;
  }
  table {
    display: flex;
  }
  thead {
    display: none;
  }
  tbody {
    width: 100%;
  }
  tr {
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.05) !important;
    margin-bottom: 24px;
    padding: 8px;
    box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
    td {
      padding: 0 4px;
      text-align: left !important;
      border: 0 !important;
      b {
        display: inline-block;
        padding: 4px 0;
      }

      &.buttons-td {
        display: flex;
        justify-content: center;
        text-align: center !important;
        margin-bottom: 8px;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #ccc !important;

        .btn-secondary {
          padding: 4px 8px;
          color: #fff !important;
        }
      }
    }
  }
}
.status-select {
  .loader {
    width: 102px;
    height: 34px;
    padding: 6px 8px;
  }
  .form-group {
    border: 0;
    background: transparent;
    color: #fff;
    padding: 0;
    width: 102px;
  }
  .form-control {
    height: 34px;
    padding-top: 0;
    padding-bottom: 0;
    overflow: hidden !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;

    option {
      background-color: #ffffff;
      color: #333333;
    }
  }
}
</style>
